import React from 'react';
import { perfTone } from './status.js';

interface PerfBarProps {
  value: number; // 0..1
  width?: number;
}

export const PerfBar: React.FC<PerfBarProps> = ({ value, width = 64 }) => {
  const tone = perfTone(value);
  const fill = tone === 'bad' ? 'bg-danger' : tone === 'warn' ? 'bg-warning' : 'bg-success';
  return (
    <span
      className="inline-block overflow-hidden rounded-sm bg-surface-alt align-middle"
      style={{ width, height: 6 }}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={1}
      aria-valuenow={value}
    >
      <span className={`block h-full ${fill}`} style={{ width: `${Math.max(0, Math.min(1, value)) * 100}%` }} />
    </span>
  );
};
